module.exports = __webpack_public_path__ + "img/red_069.68794b83.png";